import { render, staticRenderFns } from "./StateFeeInfoCard.vue?vue&type=template&id=142b0090"
import script from "./StateFeeInfoCard.vue?vue&type=script&lang=ts"
export * from "./StateFeeInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports